export enum AnnualNetIncome {
    LESS_30000 = '1B',
    BETWEEN_30001_60000 = '2B',
    BETWEEN_60001_100000 = '3B',
    BETWEEN_100001_150000 = '4B',
    MORE_150000 = '5B',
}
